import BaseService from "../base.service";

class SurveyTypeService extends BaseService {
  constructor() {
    super("survey-types");
  }
}

export default new SurveyTypeService();
